import { API_URL } from 'constants';

export const DEFAULT_ANNUAL_LEAVE_DECISION_URL = `${API_URL}/api/v1/annualleavedecision`;
